<div class="spinner-container">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 150 150"
    width="150"
    height="150"
    class="loading-spinner"
  >
    <g id="Layer_2" data-name="Layer 2">
      <circle class="circle" cx="75" cy="75" r="75" />
      <circle class="path" cx="75" cy="75" r="67.5" />
    </g>
    <g class="logo" id="Layer_3" data-name="Layer 3">
      <g>
        <rect class="cls-2" x="33.21" y="58.01" width="10.96" height="33.56" />
        <rect class="cls-2" x="55.15" y="58.15" width="10.96" height="33.56" />
        <rect class="cls-2" x="105.39" y="58.15" width="10.96" height="33.56" />
        <polygon
          class="cls-2"
          points="81.43 91.71 70.46 91.71 70.46 58.15 81.43 58.15 81.43 67.48 81.43 91.71"
        />
        <rect class="cls-1" x="44.17" y="69.45" width="10.98" height="10.98" />
        <path
          class="cls-2"
          d="M86.44,67.84s2.03.22,3.49,2.06,1.64,4.13,1.58,5.58-.64,3.82-2,5.01-3.34,1.75-4.18,1.85-3.91.12-3.91.12v9.25s6.73-.32,7.19-.65c0,0,6.52-1.22,9.67-4.87s3.96-6.72,4.21-9.31.04-7.06-1.67-10.12-4.84-6.37-10.54-7.66-8.87-.95-8.87-.95v9.33s4.9.04,5.01.36Z"
        />
      </g>
    </g>
  </svg>
</div>
